import { render, staticRenderFns } from "./TreeSelector.vue?vue&type=template&id=0fa7ef0b"
import script from "./TreeSelector.vue?vue&type=script&lang=js"
export * from "./TreeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports